import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useParams, useNavigate } from "react-router-dom";
import { baseUrl, userLocation, ipAddress, userName } from "../Univ.js";

function EditBOM() {

  const { id } = useParams();

  const [products, setProducts] = useState([]);

  const [data, setData] = useState({
    product: "",
    version: ""
  });

  useEffect(() => {
    fetchBOM();
    fetchProducts();
  }, []);

  const fetchBOM = () => {
    axios.get(baseUrl + "bom/" + id + "/")
      .then(res => {
      setData({
        product_id: res.data.product,   // 🔥 convert to string
        version: res.data.version
      });
      });
  };

  const fetchProducts = () => {
    axios.get(baseUrl + "products/")
      .then(res => {
        setProducts(res.data);
      });
  };

  const inputHandler = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value
    });
  };

  const formSubmit = () => {

    const _formData = new FormData();
    _formData.append("product", data.product);
    _formData.append("version", data.version);
    _formData.append("status", "1");
    _formData.append("addedby", userName);
    _formData.append("ip_add", ipAddress);
    _formData.append("location", userLocation);

    axios.put(baseUrl + "bom/" + id + "/", _formData, {
      headers: { "Content-Type": "multipart/form-data" }
    })
    .then(response => {
      if (response.status === 200) {

        Swal.fire({
          title: "BOM Updated",
          icon: "success",
          timer: 2000,
          showConfirmButton: false
        });

        setTimeout(() => {
          window.location.href = ('/bom/');
        }, 2000);
      }
    })
    .catch(() => {
      Swal.fire("Error", "Update failed", "error");
    });
  };

  return (
    <div className="container mt-4">
      <div className="card p-4">
        <h4>Edit BOM</h4>

            <select name="product" value={products.product_id} onChange={inputHandler} className="form-control">
                                {products.map((product,index) => {return <option key={index} value={product.id}>{product.name}
                                </option>})}
                            </select>

        <input
          type="text"
          className="form-control mt-3"
          name="version"
          value={data.version}
          onChange={inputHandler}
        />

        <button
          className="btn btn-primary mt-3"
          onClick={formSubmit}
        >
          Update
        </button>

      </div>
    </div>
  );
}

export default EditBOM;
